/**
 * Thin client component wrapper that calls initSentryFrontend() on mount.
 *
 * layout.tsx is a Server Component so it cannot call browser APIs directly.
 * This wrapper is 'use client' and runs only in the browser, which is where
 * Sentry needs to initialise.
 */
'use client';

import { useEffect } from 'react';
import { initSentryFrontend } from './sentry';

export function SentryInit(): null {
  useEffect(() => {
    initSentryFrontend();
  }, []);
  return null;
}
